
        (function() {
            // TODO: make vite read value from .env
            var explicit = 'api' || window.VITE_BACKEND_URL || window.BACKEND_URL;
            var isLocalhost = (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
            var defaultDev = 'http://localhost:3000';
            var defaultProd = 'https://app.versionary.ai';
            window.BACKEND_URL = explicit || (isLocalhost ? defaultDev : defaultProd);
            // Expose for modules loaded later
            console.log('Backend URL set to', window.BACKEND_URL);
        })();
    